import { isOnPrem } from '@/utils/buildProfile';
import { ENV_NAME, getEnvironment } from '@heidi/api/config';

/**
 * Initialises the Enhance preview sandbox in dev environments only.
 * Uses dynamic import so the SDK chunk is never shipped to staging/production.
 * The service worker file (public/enhance-sw.js) is also blocked via a
 * next.config.js beforeFiles rewrite that returns 404 in non-dev environments.
 */
export function initEnhance(): void {
  if (
    typeof window !== 'undefined' &&
    (window as Window & { __IS_E2E__?: boolean }).__IS_E2E__
  ) {
    return;
  }
  if (isOnPrem) return;
  const env = getEnvironment();
  if (env === ENV_NAME.DEV || env === ENV_NAME.AZURE_DEV) {
    void import('@enhance-eng/sandbox').then(({ enhance }) => {
      enhance();
    });
  }
}
